mutation markCommentsAsRead($input: MarkCommentsAsReadInput!) {
  markCommentsAsRead(input: $input) {
    success
    errors
  }
}
